fragment BookingInfo on property_Entry {
    mewsId
    mewsVoucherCodeDesktop
    mewsVoucherCodeMobile
    bookingsStartDate

    bookingEngineDomain
    bookingEngineId
    netAffinityChannelId
}
